<template>
    <div class="row m-0 pb-3 pb-lg-5 page">
        <template v-if="$route.name == 'Register'">
            <div class="col-lg-6 6p-3 p-lg-5 mt-3 mt-lg-5">
                <router-link tag="button" :to="{ name: 'RegisterClient'}" class="link">
                    <div class="inline">
                        <h3>Meld je aan als <br />opdrachtgever </h3>
                    </div>
                    <h3 class="inline right btn-icon"><span>&rarr;</span></h3>
                    <hr>
                </router-link>
                <p>Zoek de juiste beveiliger, brandwacht, verkeersregelaar of EHBO-er voor de opdracht en bekijk je opdrachtgeschiedenis.</p>
            </div>
            <div class="col-lg-6 p-3 p-lg-5 mt-3 mt-lg-5">
                <router-link tag="button" :to="{ name: 'RegisterProfessional'}" class="link">
                    <div class="inline">
                        <h3 >Meld je aan als <br />beveiliger </h3>
                    </div>
                    <h3 class="inline right btn-icon"><span>&rarr;</span></h3>
                    <hr>
                </router-link>
                <p>Beheer onder andere je betaalmethoden, bepaal je eigen tarief, stel je beschikbaarheid in en bekijk je opdrachtengeschiedenis.</p>
                <p><i>Verkeersregelaars, brandwachten en EHBO-ers kunnen zich hier ook aanmelden.</i></p>
            </div>
        </template>
        <div class="col-lg-6 offset-lg-3 p-3 p-lg-5" v-else>
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    }
}
</script>

<style scoped>
</style>